import Moment from 'moment';

const milliseconds = (date) => {
    if(!date) return false;

    return Moment(date.replace(/\s/, 'T')).valueOf();

}

const CMSFactory = {
    milliseconds
}

export default CMSFactory;
